import { useQuery } from "@tanstack/react-query";
import { api } from "../../../../singleton/axios";
import { ProjectionViewMode } from "../components/shared/revenueProjectionsConfig";

export interface RevenueProjectionPoint {
  date: string;
  revenue: number;
  type: "actual" | "estimate";
  revenueLow: number | null;
  revenueHigh: number | null;
  numAnalysts: number | null;
}

export interface RevenueProjectionsData {
  symbol: string;
  period: ProjectionViewMode;
  points: RevenueProjectionPoint[];
}

export function useRevenueProjections(
  symbol: string | undefined,
  period: ProjectionViewMode
) {
  return useQuery<RevenueProjectionsData, Error>({
    queryKey: ["revenueProjections", symbol, period],
    queryFn: async () => {
      if (!symbol) throw new Error("Symbol is required");

      const { data } = await api.get<RevenueProjectionsData>("/revenue-projections", {
        params: { symbol, period },
      });
      return data;
    },
    enabled: !!symbol,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000, // Keep in cache for 30 minutes
    retry: (failureCount, error) => {
      // Don't retry on 404s - no projection data exists for this stock
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if ((error as any)?.response?.status === 404) return false;
      return failureCount < 2;
    },
  });
}
